import React, { useState } from "react";
import { AlertBar } from "@/components/ms";

const DISMISSED_KEY = "banner_email_spam_dismissed";

/** Alert bar · notice. Dismissal persists in localStorage under the same key. */
export const EmailSpamBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === "1"
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "1");
    setDismissed(true);
  };

  return (
    <AlertBar tone="notice" bleed={false} onDismiss={handleDismiss}>
      <b>Check your spam folder</b> for emails from @moonscape.app and add us to your safe
      senders — we send important updates about your account.
    </AlertBar>
  );
};
